<app-programtitle title="Bonus calculator"></app-programtitle>
<p> Write a program to calculate bonus for employees, manager and CEO of a company.</p>

<app-editor code="{{program}}"> </app-editor>